module.exports = __webpack_public_path__ + "img/1@3x.b06e5f16.png";